import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import coupleReducer from './slices/coupleSlice';
import fantasyMatchReducer from './slices/fantasyMatchSlice';
import gameReducer from './slices/gameSlice';
import uiReducer from './slices/uiSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    game: gameReducer,
    couple: coupleReducer,
    fantasyMatch: fantasyMatchReducer,
    ui: uiReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
